import { useAppDispatch, useAppSelector } from '../../useReduxToolkit';
import * as realtime from '../../../features/realtime/realtime.slice';
import { RealtimeMessageType } from '../../../features/realtime/realtime.types';
import { ScreenshareRequestPayload } from '../screenshareState.types';
import { getCurrentRequestedMember } from '../../../features/screenshare/screenshare.selectors';

export const useAcceptScreenshareRequest = (): (() => Promise<void>) => {
  const dispatch = useAppDispatch();
  const currentRequestedMemberId = useAppSelector(getCurrentRequestedMember);

  const acceptScreenshareRequest = async (): Promise<void> => {
    if (currentRequestedMemberId === undefined) {
      throw new Error(
        'Screenshare accepted but currentRequestedMemberId is undefined',
      );
    }
    await dispatch(
      realtime.sendMessage({
        id: currentRequestedMemberId,
        message: {
          messageType: RealtimeMessageType.ScreenshareRequest,
          payload: { eventName: ScreenshareRequestPayload.Accept },
        },
      }),
    );
  };

  return async (): Promise<void> => {
    await acceptScreenshareRequest();
  };
};
